import File from "@/models/file";

export default class consentForm{
    constructor(){
        this.objectId=null;
        this.applicantId=null;
        this.contract=new File();
        this.consent=false;
    }
}